exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-mtoken-window{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;width:600px;height:200px}.asseco-mtoken-docpreview{border:0;width:100%;height:calc(100% - 200px)}.asseco-mtoken-fMiddle{width:50%!important;left:25%}@media only screen and (max-width:700px),screen and (max-height:510px){#asseco-mtoken-window{width:100%!important;height:100%!important;position:fixed!important;top:0;left:0}}", ""]);

// exports
